import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { GWITracker } from 'gwi-tracker';
import PropTypes from 'prop-types';
import Rating from './rating/rating';
import OverlayActionButtons from './overlay-action-buttons';
import BrickListMenu from './list/brick-list-menu';
import logger from '../../shared/helpers/logger';

class BrickOverlay extends React.Component {

  static propTypes = {
    /*eslint-disable */
    brickData: PropTypes.object.isRequired,
    /*eslint-enable */
    onRate: PropTypes.func.isRequired,
    onQueue: PropTypes.func.isRequired,
    enableHover: PropTypes.func.isRequired,
    onListMenuOpen: PropTypes.func.isRequired,
    disableHover: PropTypes.func.isRequired,
    onErasedRating: PropTypes.func.isRequired,
    onCTAClick: PropTypes.func.isRequired,
  };

  state = {
    timer: null,
    showListMenu: false,
  };

  componentDidMount = () => {
    this.state.timer = setTimeout(() => {
      this.onTransitionFinished();
    }, 500);
  };

  componentWillUnmount = () => {
    clearTimeout(this.state.timer);
  };

  onTransitionFinished = () => {
    const brickData = this.props.brickData;
    const { isModalBrick } = brickData;

    if (!isModalBrick) {
      GWITracker.trackBrickHover(brickData.trackingState);
    } else {
      logger.debug('MODAL BRICK --', 'will not fire brick hover event.');
    }
  };

  addListClick = () => {
    this.setState({ showListMenu: !this.state.showListMenu });
  };

  goBack = () => {
    logger.debug('Going back to normal overlay');
    this.setState({ showListMenu: false });
    this.props.enableHover();
  };

  renderOverlay() {
    const brickOverlayClass = (!this.state.showListMenu ? '' : ' hidden');
    const mobileOverlayClass = (this.props.brickData.isMobile ? ' mobile-overlay' : '');

    return (
      <div>
        <ReactCSSTransitionGroup
          transitionName="background"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          <div className={`brick-overlay${brickOverlayClass}${mobileOverlayClass}`}>
            <a
              className={(this.props.brickData.externalLink) ? 'brick-synopsis has-external-link' : 'brick-synopsis'}
              href={this.props.brickData.watchUrl}
              onClick={this.props.onCTAClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.brickData.annotation}
            </a>

            <Rating
              brickData={this.props.brickData}
              onRate={this.props.onRate}
              onErasedRating={this.props.onErasedRating}
            />

            <OverlayActionButtons
              brickData={this.props.brickData}
              addListClick={this.addListClick}
              onQueue={this.props.onQueue}
              disableHover={this.props.disableHover}
              onListMenuOpen={this.props.onListMenuOpen}
            />

            <div className="gwi-brick--btn-holder">
              <a
                className="gwi-brick--btn gwi-brick--btn-primary gwi-brick--btn-block"
                onClick={this.props.onCTAClick}
                target="_blank"
                rel="noopener noreferrer"
                title="Watch"
                href={this.props.brickData.watchUrl}
              >
                <span>{this.props.brickData.mainCallToAction}</span>
              </a>
            </div>
          </div>

          { BrickListMenu({
            showListMenu: this.state.showListMenu,
            goBack: this.goBack,
            brickData: this.props.brickData,
            updateUserLists: this.props.onListMenuOpen,
          }) }
        </ReactCSSTransitionGroup>
      </div>
    );
  }

  render() {
    return this.renderOverlay();
  }
}

export default BrickOverlay;



// WEBPACK FOOTER //
// ./src/client/components/brick-overlay.jsx